import React, { JSX } from 'react';

type RemoveDeviceMappingOperationProps = {
  selectedIds: string[];
  confirmed: boolean;
  submitting: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
};

export default function RemoveDeviceMappingOperation(
  props: RemoveDeviceMappingOperationProps,
): JSX.Element {
  const { selectedIds, confirmed, submitting, onConfirmedChange } = props;

  return (
    <div className="border border-red-200 dark:border-red-900/50 rounded-lg p-3 bg-red-50 dark:bg-red-950/20">
      <h3 className="text-xs font-semibold text-red-900 dark:text-red-200">Remove from device mappings</h3>
      <p className="mt-1 text-[11px] text-red-800 dark:text-red-300">
        Deletes each selected device&apos;s row from the device mappings table (DynamoDB). This affects
        device representation across the entire business and cannot be undone from here.
      </p>

      <div className="mt-3 border border-red-200 dark:border-red-900/50 rounded-md p-2 bg-white dark:bg-slate-950/40">
        <div className="text-[11px] text-gray-800 dark:text-slate-200 font-medium mb-1">
          Selected devices ({selectedIds.length})
        </div>
        <div className="max-h-28 overflow-auto">
          {selectedIds.length > 0 ? (
            selectedIds.map((id) => (
              <div key={id} className="font-mono text-[11px] break-all text-gray-800 dark:text-slate-200">
                {id}
              </div>
            ))
          ) : (
            <div className="text-[11px] text-gray-400 dark:text-slate-400">No devices selected.</div>
          )}
        </div>
      </div>

      <label className="mt-3 flex items-center gap-2 text-[11px] text-red-900 dark:text-red-200">
        <input
          type="checkbox"
          checked={confirmed}
          disabled={submitting}
          onChange={(e) => onConfirmedChange(e.target.checked)}
        />
        I understand this removes {selectedIds.length} device{selectedIds.length === 1 ? '' : 's'} from the
        mappings table.
      </label>
    </div>
  );
}
